import { render, staticRenderFns } from "./AlibiAlbum.vue?vue&type=template&id=1852762a"
import script from "./AlibiAlbum.vue?vue&type=script&lang=js"
export * from "./AlibiAlbum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports